import styled, { keyframes } from "styled-components";
import wave from "../../assets/wave_gray.svg";
import rocket from "../../assets/programming.svg";
import human from "../../assets/hombre.svg";
import hand from "../../assets/hand.svg";
import Fade from "react-reveal/Fade";

const move = keyframes`
0% { transform: translateY(-5px)         }
    50% { transform: translateY(10px) translateX(10px)        }
    100% { transform: translateY(-5px)         }
`;

const AboutSection = styled.section`
  width: 100vw;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Waves = styled.img`
  width: 100%;
  height: auto;
  position: absolute;
  top: -1rem;
`;
const Hand = styled.div`
  position: absolute;
  bottom: -1rem;
  right: 0;

  @media only Screen and (max-width: 40em) {
    display: none;
  }
`;

const Main = styled.div`
  margin: 0 15rem;
  margin-top: 15rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  @media only Screen and (max-width: 64em) {
    margin: 0 calc(5rem + 5vw);
    margin-top: 10rem;
  }
  @media only Screen and (max-width: 40em) {
    align-items: center;
    margin: 3rem calc(3rem + 3vw);
  }
`;

const Title = styled.h1`
  font-size: 2rem;
  display: inline-block;
`;

const CurvedLine = styled.div`
  width: 7rem;
  height: 2rem;
  border: solid 5px var(--purple);
  border-color: var(--purple) transparent transparent transparent;
  /* border-radius: 150%/60px 70px 0 0; */
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only Screen and (max-width: 40em) {
    flex-direction: column;
  }
`;

const Rocket = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  width: 70%;
  padding-bottom: 5rem;
  margin-right: 10rem;
  /* animation: ${move} 2.5s ease infinite; */
  @media only Screen and (max-width: 40em) {
    width: 50vw;
    padding-bottom: 0;
  }
`;

const Human = styled.div`
  width: 45%;
  position: absolute;
  right: 0;
  bottom: 100%;

  @media only Screen and (max-width: 40em) {
    display: none;
  }
`;
const Text = styled.h4`
  font-size: calc(0.5rem + 1vw);
  line-height: 1.5;
  color: var(--nav2);
`;
const Circle = styled.span`
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background-color: black;
  margin-right: 0.5rem;
  margin-top: 1rem;
`;
const AboutText = styled.div`
  width: 50%;
  position: relative;
  @media only Screen and (max-width: 40em) {
    width: 100%;
  }
`;

const About = () => {
  return (
    <AboutSection id="about1">
      <Waves src={wave} alt="" />
      {/* <Hand>
        <img src={hand} alt="" />
      </Hand> */}
      <Main>
        <div>
          <Fade left>
            <Title className="aboutUsTitle">About Us</Title>
          </Fade>
          <CurvedLine className="curvedLineCls" />
        </div>
        <Content>
          <Rocket className="rocketImgDivCls">
            <img src={rocket} alt="" width="400" height="400" />
          </Rocket>
          <AboutText>
            {/* <Human className="humanImgDivCls">
              <img src={human} alt="" width="400" height="300" />
            </Human> */}
            <Fade right>
              <Text className="aboutUsTxtDivCls">
                We are proud to be problem solvers. We like the people we work
                with – coworkers, clients – and genuinely enjoy helping one
                another succeed.
              </Text>
            </Fade>
            {/* <div>
              <Circle style={{ backgroundColor: "var(--purple)" }} />
              <Circle style={{ backgroundColor: "var(--pink)" }} />
              <Circle style={{ backgroundColor: "var(--black)" }} />
            </div> */}
          </AboutText>
        </Content>
      </Main>
    </AboutSection>
  );
};

export default About;
